export const EXPORT_INTERFACE_ERROR_MODAL_ID = "exportInterfaceErrorModalId";
export const EXPORT_INTERFACE_ERROR_MODAL_WIDTH = "700px";
